import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import H5 from '@base/H5/H5';
import P1 from '@base/P1/P1';
import Image from '@base/Image';
import LottieAnimation from '@base/LottieAnimation/LottieAnimation';
import { getAnimationPath } from '@utils/animationHelpers';
import { DOUBT_STATE } from './constants';

const DoubtCardWrapper = styled.div`
  width: 656px;
  height: 334px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--color-divider);
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    max-width: 360px;
    text-align: center;
    margin-top: ${Spacings.SPACING_8B};
  }
`;
const DoubtCardHeading = styled(H5)`
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
    margin-top: ${Spacings.SPACING_6B};
  }
`;
const DoubtCardSubText = styled(P1)`
  margin-top: ${Spacings.SPACING_1B};
  color: var(--color-text-secondary);
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.ULTRA_SMALL};
  }
`;

const AnimationContainer = styled(LottieAnimation)`
  width: ${Spacings.SPACING_20B};
  height: ${Spacings.SPACING_20B};
`;

const AnimationFallBackImage = ({ imageURL }) => {
  return <Image src={imageURL} width={80} height={80} alt="doubt-state-card" />;
};

const DoubtStateCard = ({ cardDetails }) => {
  const { imageURL, heading, subText, animation } = cardDetails || {};
  const { doubtSubmitted, invalidDoubt, noSolutionAvailable, findingSolution } =
    DOUBT_STATE;
  const animationStateObj = {
    [doubtSubmitted.animation]: 'doubtsOnWeb/doubtsSubmitted.json',
    [invalidDoubt.animation]: 'doubtsOnWeb/invalidDoubts.json',
    [noSolutionAvailable.animation]: 'doubtsOnWeb/noSolutionsAvailableAni.json',
    [findingSolution.animation]: 'doubtsOnWeb/searchingForSolution.json'
  };
  const getAnimationBasedOnState = () => {
    return animationStateObj[animation];
  };

  return (
    <>
      {heading && (
        <DoubtCardWrapper>
          <AnimationContainer
            Fallback={<AnimationFallBackImage imageURL={imageURL} />}
            src={getAnimationPath(getAnimationBasedOnState())}
          />
          <DoubtCardHeading>{heading}</DoubtCardHeading>
          <DoubtCardSubText>{subText}</DoubtCardSubText>
        </DoubtCardWrapper>
      )}
    </>
  );
};

export default DoubtStateCard;
